import { jsx as _jsx } from "react/jsx-runtime";
import List from "components/Lists/List";
import DELETE_EMAILS_TEMPLATES from "mutations/emails/deleteEmailsTemplate";
import GET_EMAILS_TEMPLATES from "queries/emails/getEmailsTemplates";
const TemplatesList = () => (_jsx(List, { deleteMutation: DELETE_EMAILS_TEMPLATES, itemNamePlural: "templates", label: "Templates", listQuery: GET_EMAILS_TEMPLATES, listQueryDataName: "getEmailsTemplates", pathPrefix: "/emails" }));
export default TemplatesList;
